module.exports = __webpack_public_path__ + "07_mole.0c0970bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer2/07_mole.png
// module id = zhsT
// module chunks = 0